import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const Option = Select.Option;

const FirstRegimeField = ({ article, onArticleChange, regimeVal, setRegimeVal, regimeFind, isAccountRow, isMonoRegime }) => { 
  const dispatch = useDispatch();
  const regimes = useSelector(state => state.precog.vat.regimes);

  const [regimesList, setRegimesList] = useState([]);

  useEffect(() => {
    if (!article?.regimeId) return;
    setRegimeVal(article.regimeId);
  }, [article?.regimeId]);

  useEffect(() => {
    if (!regimes?.list) return;
    const optionRegimes = [];
    regimes.list.forEach((el, index) => {
      optionRegimes.push(<Option
        value={el.id} key={`regime_option_${index}`}>{el.description}
      </Option>);
    });
    setRegimesList(optionRegimes);
  }, [regimes?.list]);

  return (
    <>
      <Select
        data-testid={"RegimeFields"}
        showSearch
        value={regimeVal}
        style={{
          width: isAccountRow ? (regimeFind && regimeFind.field) ? "60%" : "100%": (regimeFind && regimeFind.field) ? "160px" : isMonoRegime !== "MULTI" ? "200px" : "322px"
        }}
        dropdownClassName={isAccountRow ? "articles-accordion-select-container" : "split-article-input-accordion"}
        placeholder="Seleziona il regime"
        optionFilterProp="children"
        className={isAccountRow ? "articles-accordion-select" : "split-article-input"}
        getPopupContainer={trigger => isAccountRow ? document.querySelector(".ant-table-tbody") : trigger.parentNode}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onSelect={ (val) => {
          setRegimeVal(val);
          dispatch({type: "STOP_ACCOUNTS_REFRESH"});
          onArticleChange("regimeId", val);
        }}
      >
        {regimesList}
      </Select>
    </>
  );
};

export default FirstRegimeField;
